<!-- =========================================================================================
    File Name: TableSingleSelected.vue
    Description: Add functionality on selecting row
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mt-12 md:mt-0">
      <vx-card>
        <div>
          <div class="vx-col w-full">
            <div class="mb-4 flex flex-wrap justify-between">
              <div class="mb-4 flex flex-wrap">
                <vs-input class="sm:mr-4" v-model="serverParams.keyword" @keyup.enter="onSearch" placeholder="교재코드" />
                <vs-select class="sm:mr-4" v-model="serverParams.unitCode" name="item-unit-code">
                  <vs-select-item :key="item.value" :value="item.value" :text="item.label" v-for="item in unitList"/>
                </vs-select>
                <vs-select class="sm:mr-4" v-model="serverParams.stepCode" name="item-step-code" >
                  <vs-select-item :key="item.value" :value="item.value" :text="item.label" v-for="item in stepList" />
                </vs-select>
                <vs-button color="primary" type="border" icon-pack="feather" icon="icon-search" @click="onSearch"></vs-button>
              </div>
              <div class="justify-end">
                <vs-button class="" @click="onAdd">컨텐츠 추가</vs-button>
              </div>
            </div>
          </div>
          
          <vue-good-table
            mode="remote"
            isLoading.sync="isLoading"
            @on-page-change="onPageChange"
            @on-per-page-change="onPerPageChange"
            @on-row-click="onRowClick"
            :pagination-options="{
              enabled: true,
              dropdownAllowAll: false,
              nextLabel: '',
              prevLabel: '',
              rowsPerPageLabel: '',
              perPage: 20
            }"
            :sort-options="{
              enabled: false
            }"
            :columns="columns"
            :rows="rows"
            :totalRows="totalRecords"
            :fix-header="true"
            :line-numbers="false"
            styleClass="vgt-table condensed">

            <!-- <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'action'">
              <vs-button size="small" color="danger" type="flat" icon-pack="feather" icon="icon-delete" @click="deleteContent(props.row)">삭제</vs-button>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template> -->

          </vue-good-table>
        </div>
      </vx-card> 
      </div>
    </div>  
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import { fetchData } from '@/api/module'

export default {
  components: {
    VueGoodTable
  },
  watch: {
    
  },   
  data () {
    return {
      isLoading: false,
      unitList: [],
      stepList: [],
      columns: [
        {
          label: 'No.',
          field: 'studyContentSeq',
          type: 'name',
          sortable: false
        },
        {
          label: 'BookCode',
          field: 'bookCode',
          type: 'name',
          sortable: false
        },
        {
          label: 'UnitCode',
          field: 'unitCode',
          type: 'name',
          sortable: false
        },
        {
          label: 'StepCode',
          field: 'stepCode',
          type: 'name',
          sortable: false
        },
        {
          label: 'MenuCode',
          field: 'menuCode',
          type: 'name',
          sortable: false
        },
        {
          label: 'StepName',
          field: 'stepName',
          type: 'name',
          sortable: false
        },
        {
          label: 'MenuName',
          field: 'menuName',
          type: 'name',
          sortable: false
        }
        // {
        //   label: 'Question',
        //   field: 'question',
        //   type: 'name',
        //   sortable: false
        // }
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        page: 1,
        perPage: 20,
        unitCode: '',
        keyword: '',
        stepCode: ''
      }
    }
  },
  methods: {
    
    updateParams () {
      const newObj = Object.assign({}, this.serverParams)
      this.$store.dispatch('setContentsParams', newObj)
    },
    onAdd () {
      this.$router.push('/content/content-add')
    },
    onRowClick (params) {
      const studyContentSeq = params.row.studyContentSeq
      this.$router.push(`/content/content-edit/${studyContentSeq}`)
    },
    onPageChange (params) {
      this.serverParams.page = params.currentPage
      this.loadItems()
    },
    onPerPageChange (params) {
      this.serverParams.perPage = params.currentPerPage
      this.serverParams.page = 1
      this.loadItems()
    },
    onSearch () {
      this.serverParams.page = 1
      this.loadItems()
    },
    async loadItems () { 
      try {
        
        this.updateParams()

        const { data } = await fetchData('study-contents', this.serverParams)
        this.$vs.loading.close()
        this.totalRecords = data.count
        this.rows = data.list 
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }    
    }
    
  },
  created () {
    //this.bookSeq = this.$route.params.bookSeq

    this.unitList.push({label: '[전체]', value: ''})   
    this.unitList.push({label: 'U01', value: 'U01'})   
    this.unitList.push({label: 'U02', value: 'U02'})   
    this.unitList.push({label: 'U03', value: 'U03'})   
    this.unitList.push({label: 'U04', value: 'U04'})   
    this.unitList.push({label: 'U05', value: 'U05'})   
    this.unitList.push({label: 'U06', value: 'U06'})
    this.unitList.push({label: 'U07', value: 'U07'})
    this.unitList.push({label: 'U08', value: 'U08'})
    this.unitList.push({label: 'U09', value: 'U09'})
    this.unitList.push({label: 'U10', value: 'U10'})
    this.unitList.push({label: 'U11', value: 'U11'})
    this.unitList.push({label: 'U12', value: 'U12'})
    this.unitList.push({label: 'U13', value: 'U13'})
    this.unitList.push({label: 'U14', value: 'U14'})
    this.unitList.push({label: 'U15', value: 'U15'})
    this.unitList.push({label: 'U16', value: 'U16'})
    this.unitList.push({label: 'U17', value: 'U17'})
    this.unitList.push({label: 'U18', value: 'U18'})
    this.unitList.push({label: 'U19', value: 'U19'})
    this.unitList.push({label: 'U20', value: 'U20'})
    this.unitList.push({label: 'U21', value: 'U21'})
    this.unitList.push({label: 'U22', value: 'U22'})
    this.unitList.push({label: 'U23', value: 'U23'})
    this.unitList.push({label: 'U24', value: 'U24'})
    this.unitList.push({label: 'U25', value: 'U25'})
    this.unitList.push({label: 'U26', value: 'U26'})
    this.unitList.push({label: 'U27', value: 'U27'})
    this.unitList.push({label: 'U28', value: 'U28'})
    this.unitList.push({label: 'U29', value: 'U29'})
    this.unitList.push({label: 'U30', value: 'U30'})
    this.unitList.push({label: 'U31', value: 'U31'})
    this.unitList.push({label: 'U32', value: 'U32'})
    this.unitList.push({label: 'U33', value: 'U33'})
    this.unitList.push({label: 'U34', value: 'U34'})
    this.unitList.push({label: 'U35', value: 'U35'})
    this.unitList.push({label: 'U36', value: 'U36'})
    this.unitList.push({label: 'U37', value: 'U37'})
    this.unitList.push({label: 'U38', value: 'U38'})
    this.unitList.push({label: 'U39', value: 'U39'})
    this.unitList.push({label: 'U40', value: 'U40'})
    this.unitList.push({label: 'U41', value: 'U41'})
    this.unitList.push({label: 'U42', value: 'U42'})
    this.unitList.push({label: 'U43', value: 'U43'})
    this.unitList.push({label: 'U44', value: 'U44'})
    this.unitList.push({label: 'U45', value: 'U45'})
    this.unitList.push({label: 'U46', value: 'U46'})
    this.unitList.push({label: 'U47', value: 'U47'})
    this.unitList.push({label: 'U48', value: 'U48'})
    this.unitList.push({label: 'U49', value: 'U49'})
    this.unitList.push({label: 'U50', value: 'U50'})

    this.stepList.push({label: '[전체]', value: ''})   
    this.stepList.push({label: 'SP-Dictation', value: 'SP05'})
    this.stepList.push({label: 'SP-Let\'s Drill', value: 'SP07'})
    this.stepList.push({label: 'SP-Listen Up', value: 'SP09'})
    this.stepList.push({label: 'SP-Listening', value: 'SP01'})
    this.stepList.push({label: 'SP-Phonics', value: 'SP04'})
    this.stepList.push({label: 'SP-Read All About', value: 'SP11'})
    this.stepList.push({label: 'SP-Reading', value: 'SP03'})
    this.stepList.push({label: 'SP-Speak Up', value: 'SP08'})
    this.stepList.push({label: 'SP-Speaking', value: 'SP06'})
    this.stepList.push({label: 'SP-Vocabulary', value: 'SP02'})
    this.stepList.push({label: 'SP-Writing', value: 'SP10'})
    this.stepList.push({label: 'SP-Check Up', value: 'SP12'})

    this.stepList.push({label: 'RD-Dictation', value: 'RD03'})
    this.stepList.push({label: 'RD-Listening', value: 'RD01'})
    this.stepList.push({label: 'RD-Reading', value: 'RD04'})
    this.stepList.push({label: 'RD-Vocabulary', value: 'RD02'})
    this.stepList.push({label: 'RD-Writing', value: 'RD05'})

    this.stepList.push({label: 'PH-Phonics', value: 'PH01'})


    this.stepList.push({label: 'VC-Vocabulary', value: 'VC01'})

    this.stepList.push({label: 'GR-Grammar Note', value: 'GR01'})
    
    this.stepList.push({label: 'WR-Basic Writing', value: 'WR01'})
    
    const params = this.$store.getters.getContentsParams
    this.serverParams = Object.assign({}, params)
    this.loadItems()
  }
}
</script>
